class EditTeamController {
    constructor($window, TeamServiceApi, toastr, ScriptInjectionService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                team: {},
                newName: ''
            };
            this.data.team = this.resolve.team;
            this.data.newName = this.data.team.Name;
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.ok = () => {
            let teamId = this.data.team.Id;
            let teamName = this.data.newName;
            if (teamName === null || teamName === '') {
                this.toastr.error('Please enter a team name and submit again!');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(teamName)) {
                this.toastr.error('Name contains illegal characters');
                return;
            }
            if (teamName.length > 127) {
                this.toastr.error('Name must be less than 128 characters');
                return;
            }
            let req = {
                Id: teamId,
                Name: teamName,
                LastAmended: null, // value assigned at server side, use strong type rather than anonymous
                LastAmendedBy: 0
            };
            this.TeamService.addUpdateTeam(req).then((response) => {
                let team = response.data;
                this.close({ $value: team });
            });
        };
        this.checkScriptInjection = (textValue) => {
            let injectionArray = ['<', '>', ';', '{', '}'];
            let arrayLength = injectionArray.length;
            for (let index = 0; index < arrayLength; index++) {
                if (textValue.indexOf(injectionArray[index]) > -1) {
                    return true;
                }
            }
            return false;
        };
        this.window = $window;
        this.TeamService = TeamServiceApi;
        this.toastr = toastr;
        this.ScriptInjectionService = ScriptInjectionService;
    }
}
angular.module('app').component('editTeamModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TeamAdmin/edit-team.tpl.html',
    controllerAs: 'vm',
    controller: EditTeamController
});
